// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* StoreOrderTab specific styles - scoped to avoid conflicts with StoreOrderHistory */
.store-order-tab-wrapper .flex-container {
  display: grid !important;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 2rem !important;
  font-size: medium;
  font-weight: bold;
  margin: 0.5rem 0 !important;
}

.store-order-tab-wrapper .flex-container div {
  padding: 10px !important;
  text-align: left !important;
}

.store-order-tab-wrapper .flex-container.right-align {
  justify-content: flex-end !important;
}

.store-order-tab-wrapper .flex-container-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;
}

.store-order-tab-wrapper .flex-container-button.right-align {
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: nowrap;
  margin-right: 10px;
}

.store-order-tab-wrapper .flex-container-button.right-align > div {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
}

.store-order-tab-wrapper .dropdown {
  margin-left: -4px !important;
  padding: 4px !important;
  width: 105% !important;
  margin-top: -2rem !important;
  border-radius: 4px !important;
  border: 1px solid #ccc !important;
  font-weight: normal !important;
}

.store-order-tab-wrapper .inner-box {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  position: relative !important;
}

.store-order-tab-wrapper .input-field,
.store-order-tab-wrapper .input-fields-so,
.store-order-tab-wrapper .input-fields.mafield,
.store-order-tab-wrapper .input-fields.store-order-nbr {
  padding: 4px !important;
  border-radius: 4px !important;
  border: 1px solid #ccc !important;
  font-size: medium !important;
  box-sizing: border-box !important;
  vertical-align: middle !important;
  font-weight: normal !important;
  color: black !important;
}

.store-order-tab-wrapper .input-field {
  margin-left: -3px !important;
  width: 15rem !important;
  margin-top: -2rem !important;
}

.store-order-tab-wrapper .input-fields-so {
  margin-left: -3px !important;
  width: 101% !important;
  margin-top: -2rem !important;
}

.store-order-tab-wrapper .input-fields.mafield {
  margin-left: -3px;
  width: 87%;
  margin-top: -2rem;
}

.store-order-tab-wrapper .input-fields.store-order-nbr {
  width: 331%;
}

.store-order-tab-wrapper .input-field::placeholder {
  color: #808080;
  font-style: italic;
  font-size: medium;
  opacity: 0.8;
}

.store-order-tab-wrapper .mt15 {
  margin-top: 15px;
}

.store-order-tab-wrapper .mt-1rem {
  margin-top: -1rem !important;
}

.store-order-tab-wrapper .margin-left {
  margin-left: 25px;
}

.store-order-tab-wrapper .margin-top-29px {
  margin-top: -29px;
}

.store-order-tab-wrapper .tab-color {
  font-size: 25px;
  padding: 25px;
}

.store-order-tab-wrapper .text-light-text {
  --tw-text-opacity: 1;
  color: rgb(90 105 123 / var(--tw-text-opacity));
}

.store-order-tab-wrapper .button-white-bg {
  background-color: white;
  color: #007BFF;
  border: 2px solid #007BFF;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: medium;
  transition: background-color 0.3s, color 0.3s;
  min-width: 166px;
}

.store-order-tab-wrapper .button-clear-bg {
  min-width: 166px;
}

.store-order-tab-wrapper .custom-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-order-tab-wrapper .custom-popup {
  background: #fff;
  padding: 2rem;
  border-radius: 8px;
  min-width: 300px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.store-order-tab-wrapper .popup-heading {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.store-order-tab-wrapper .popup-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.store-order-tab-wrapper .ok-button {
  background-color: #2e7d32;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.store-order-tab-wrapper .ok-button:hover {
  background-color: #1b5e20;
}

.store-order-tab-wrapper .cancel-button {
  background-color: #795548;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
}

.store-order-tab-wrapper .cancel-button:hover {
  background-color: #5d4037;
}

.store-order-tab-wrapper .close-btn {
  background: none;
  border: none;
  font-size: 18px;
  margin-left: 12px;
  cursor: pointer;
}

.store-order-tab-wrapper .file-name {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #333;
}

.store-order-tab-wrapper .upload-button-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.store-order-tab-wrapper .upload-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.store-order-tab-wrapper .file-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.store-order-tab-wrapper .delete-icon {
  cursor: pointer;
  color: #d9534f;
  font-size: 1.2rem;
  -webkit-user-select: none;
          user-select: none;
  padding: 0 6px;
  margin-top: -32px;
}

.store-order-tab-wrapper .error-message {
  color: red;
  font-size: 0.9rem;
  margin-top: 4px;
}

/* Uniform spacing only for the first row (Source/DC/Division) */
.store-order-tab-wrapper .flex-container:nth-of-type(2) .inner-box select.dropdown,
.store-order-tab-wrapper .flex-container:nth-of-type(2) .inner-box input.input-fields-so {
  margin-top: -15px !important;
}

/* Uniform spacing for MA Target/Target Kafka Topic row */
.store-order-tab-wrapper .flex-container:nth-of-type(12) .inner-box select.dropdown,
.store-order-tab-wrapper .flex-container:nth-of-type(12) .inner-box input.input-fields-so {
  margin-top: -15px !important;
}

/* Uniform spacing for Target Process Date/Target Delivery Date row */
.store-order-tab-wrapper .flex-container:nth-of-type(11) > div > div[class*="date"],
.store-order-tab-wrapper .flex-container:nth-of-type(11) > div DateSelector {
  margin-top: -25px !important;
}

/* Additional DateSelector targeting for all date rows */
.store-order-tab-wrapper .flex-container.mt-1rem > div > div[class*="date"],
.store-order-tab-wrapper .flex-container.mt-1rem DateSelector {
  margin-top: -25px !important;
}

/* Additional specific targeting for mafield elements */
.store-order-tab-wrapper .flex-container .inner-box select.dropdown.mafield,
.store-order-tab-wrapper .flex-container .inner-box input.input-fields-so.mafield {
  margin-top: -15px !important;
}

.store-order-tab-wrapper .no-access-message {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  font-style: italic !important;
  text-align: center !important;
  padding: 8px 12px !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 4px !important;
  cursor: not-allowed !important;
  margin-top: -2rem !important;
  margin-left: -4px !important;
  width: 105% !important;
  font-weight: normal !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/common/tab/storeOrder/StoreOrderTab.css"],"names":[],"mappings":"AAAA,qFAAqF;AACrF;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;;;;EAIE,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;EAC5B,iCAAiC;EACjC,iCAAiC;EACjC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;AACjB;;AAEA,gEAAgE;AAChE;;EAEE,4BAA4B;AAC9B;;AAEA,yDAAyD;AACzD;;EAEE,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;;EAEE,4BAA4B;AAC9B;;AAEA,wDAAwD;AACxD;;EAEE,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;AAChC","sourcesContent":["/* StoreOrderTab specific styles - scoped to avoid conflicts with StoreOrderHistory */\n.store-order-tab-wrapper .flex-container {\n  display: grid !important;\n  grid-template-columns: 1fr 1fr 1fr !important;\n  gap: 2rem !important;\n  font-size: medium;\n  font-weight: bold;\n  margin: 0.5rem 0 !important;\n}\n\n.store-order-tab-wrapper .flex-container div {\n  padding: 10px !important;\n  text-align: left !important;\n}\n\n.store-order-tab-wrapper .flex-container.right-align {\n  justify-content: flex-end !important;\n}\n\n.store-order-tab-wrapper .flex-container-button {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem 0;\n}\n\n.store-order-tab-wrapper .flex-container-button.right-align {\n  justify-content: flex-end;\n  gap: 10px;\n  flex-wrap: nowrap;\n  margin-right: 10px;\n}\n\n.store-order-tab-wrapper .flex-container-button.right-align > div {\n  display: flex;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.store-order-tab-wrapper .dropdown {\n  margin-left: -4px !important;\n  padding: 4px !important;\n  width: 105% !important;\n  margin-top: -2rem !important;\n  border-radius: 4px !important;\n  border: 1px solid #ccc !important;\n  font-weight: normal !important;\n}\n\n.store-order-tab-wrapper .inner-box {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  position: relative !important;\n}\n\n.store-order-tab-wrapper .input-field,\n.store-order-tab-wrapper .input-fields-so,\n.store-order-tab-wrapper .input-fields.mafield,\n.store-order-tab-wrapper .input-fields.store-order-nbr {\n  padding: 4px !important;\n  border-radius: 4px !important;\n  border: 1px solid #ccc !important;\n  font-size: medium !important;\n  box-sizing: border-box !important;\n  vertical-align: middle !important;\n  font-weight: normal !important;\n  color: black !important;\n}\n\n.store-order-tab-wrapper .input-field {\n  margin-left: -3px !important;\n  width: 15rem !important;\n  margin-top: -2rem !important;\n}\n\n.store-order-tab-wrapper .input-fields-so {\n  margin-left: -3px !important;\n  width: 101% !important;\n  margin-top: -2rem !important;\n}\n\n.store-order-tab-wrapper .input-fields.mafield {\n  margin-left: -3px;\n  width: 87%;\n  margin-top: -2rem;\n}\n\n.store-order-tab-wrapper .input-fields.store-order-nbr {\n  width: 331%;\n}\n\n.store-order-tab-wrapper .input-field::placeholder {\n  color: #808080;\n  font-style: italic;\n  font-size: medium;\n  opacity: 0.8;\n}\n\n.store-order-tab-wrapper .mt15 {\n  margin-top: 15px;\n}\n\n.store-order-tab-wrapper .mt-1rem {\n  margin-top: -1rem !important;\n}\n\n.store-order-tab-wrapper .margin-left {\n  margin-left: 25px;\n}\n\n.store-order-tab-wrapper .margin-top-29px {\n  margin-top: -29px;\n}\n\n.store-order-tab-wrapper .tab-color {\n  font-size: 25px;\n  padding: 25px;\n}\n\n.store-order-tab-wrapper .text-light-text {\n  --tw-text-opacity: 1;\n  color: rgb(90 105 123 / var(--tw-text-opacity));\n}\n\n.store-order-tab-wrapper .button-white-bg {\n  background-color: white;\n  color: #007BFF;\n  border: 2px solid #007BFF;\n  border-radius: 4px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: medium;\n  transition: background-color 0.3s, color 0.3s;\n  min-width: 166px;\n}\n\n.store-order-tab-wrapper .button-clear-bg {\n  min-width: 166px;\n}\n\n.store-order-tab-wrapper .custom-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.store-order-tab-wrapper .custom-popup {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 8px;\n  min-width: 300px;\n  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n\n.store-order-tab-wrapper .popup-heading {\n  margin-top: 0;\n  margin-bottom: 12px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.store-order-tab-wrapper .popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.store-order-tab-wrapper .ok-button {\n  background-color: #2e7d32;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.store-order-tab-wrapper .ok-button:hover {\n  background-color: #1b5e20;\n}\n\n.store-order-tab-wrapper .cancel-button {\n  background-color: #795548;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.store-order-tab-wrapper .cancel-button:hover {\n  background-color: #5d4037;\n}\n\n.store-order-tab-wrapper .close-btn {\n  background: none;\n  border: none;\n  font-size: 18px;\n  margin-left: 12px;\n  cursor: pointer;\n}\n\n.store-order-tab-wrapper .file-name {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  color: #333;\n}\n\n.store-order-tab-wrapper .upload-button-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.store-order-tab-wrapper .upload-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.store-order-tab-wrapper .file-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.store-order-tab-wrapper .delete-icon {\n  cursor: pointer;\n  color: #d9534f;\n  font-size: 1.2rem;\n  user-select: none;\n  padding: 0 6px;\n  margin-top: -32px;\n}\n\n.store-order-tab-wrapper .error-message {\n  color: red;\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\n/* Uniform spacing only for the first row (Source/DC/Division) */\n.store-order-tab-wrapper .flex-container:nth-of-type(2) .inner-box select.dropdown,\n.store-order-tab-wrapper .flex-container:nth-of-type(2) .inner-box input.input-fields-so {\n  margin-top: -15px !important;\n}\n\n/* Uniform spacing for MA Target/Target Kafka Topic row */\n.store-order-tab-wrapper .flex-container:nth-of-type(12) .inner-box select.dropdown,\n.store-order-tab-wrapper .flex-container:nth-of-type(12) .inner-box input.input-fields-so {\n  margin-top: -15px !important;\n}\n\n/* Uniform spacing for Target Process Date/Target Delivery Date row */\n.store-order-tab-wrapper .flex-container:nth-of-type(11) > div > div[class*=\"date\"],\n.store-order-tab-wrapper .flex-container:nth-of-type(11) > div DateSelector {\n  margin-top: -25px !important;\n}\n\n/* Additional DateSelector targeting for all date rows */\n.store-order-tab-wrapper .flex-container.mt-1rem > div > div[class*=\"date\"],\n.store-order-tab-wrapper .flex-container.mt-1rem DateSelector {\n  margin-top: -25px !important;\n}\n\n/* Additional specific targeting for mafield elements */\n.store-order-tab-wrapper .flex-container .inner-box select.dropdown.mafield,\n.store-order-tab-wrapper .flex-container .inner-box input.input-fields-so.mafield {\n  margin-top: -15px !important;\n}\n\n.store-order-tab-wrapper .no-access-message {\n  background-color: #f8f9fa !important;\n  color: #6c757d !important;\n  font-style: italic !important;\n  text-align: center !important;\n  padding: 8px 12px !important;\n  border: 1px solid #dee2e6 !important;\n  border-radius: 4px !important;\n  cursor: not-allowed !important;\n  margin-top: -2rem !important;\n  margin-left: -4px !important;\n  width: 105% !important;\n  font-weight: normal !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
